import Vue from "vue";
import VueI18n from "vue-i18n";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueScrollTo from "vue-scrollto";
// import vuetify from "./plugins/vuetify";
import { Icon } from "leaflet";
import "leaflet.icon.glyph";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faHome, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faHome, faSearch);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// import "flag-icon-css/css/flag-icon.min.css";
import "leaflet/dist/leaflet.css";
// import FlagIcon from "vue-flag-icon";

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

Vue.config.productionTip = false;

Vue.use(VueI18n);
// Vue.use(FlagIcon);
Vue.use(VueScrollTo);
Vue.use(BootstrapVue);

new Vue({
  i18n,
  router,
  store,
  // vuetify,
  render: h => h(App)
}).$mount("#app");
